import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-view-grid",
  "use": "icon-view-grid-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-view-grid\"><path d=\"M128 469.333333h341.333333V128H128m0 768h341.333333v-341.333333H128m426.666667 341.333333h341.333333v-341.333333h-341.333333m0-426.666667v341.333333h341.333333V128\" fill=\"\" p-id=\"23990\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol